import { ReactElement } from "react";

import WelcomeAppFrame from "appFrames/welcomeAppFrame/WelcomeAppFrame";

import RecoverUsername from "pages/recoverUsername/RecoverUsername";

const RecoverUsernameApp = (): ReactElement => (
  <WelcomeAppFrame>
    <RecoverUsername />
  </WelcomeAppFrame>
);

export default RecoverUsernameApp;
